import { Accordion } from "native-base";

export default Accordion;